import React, { useEffect, useState } from "react";
import { HiOutlineTicket } from "react-icons/hi";
import { Assort } from "../../../models/Assort";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";

import { BiInfoCircle } from "react-icons/bi";

import HtmlTooltip from "@mui/material/Tooltip";
import { TicketAccess } from "../../../models/TicketAccess";
import "../../../../style/buttons.scss";
import getId from "../../../../utils/getId";
import { BasketItem } from "../../../models/BasketItem";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";
import { QntStateItem } from "../../../models/QntStateItem";

interface IProps {
  ticketLimit?: number;
  item: Assort;
  exercise?: TicketAccess;
  preBasket: BasketItem[];
  addItemToBasket: (assort: Assort, exercise?: TicketAccess) => void;
  removeItemFromBasket: (assort: Assort, exercise?: TicketAccess) => void;
  qntState?: QntStateItem[];
} // optional for styling

const TicketLineSummary: React.FC<IProps> = ({
  item,
  exercise,
  preBasket,
  ticketLimit,
  addItemToBasket,
  removeItemFromBasket,
  qntState,
}: IProps) => {
  const { t } = useTranslation();

  const getQnt = (value: Assort): number => {
    if (qntState && qntState.length > 0 && exercise) {
      const foundQnt = qntState.find(
        (item) => item.assortIds === getId(value) && item.exerciseIds === exercise.exerciseIds
      );
      return foundQnt ? foundQnt.count : 0;
    } else {
      const itemBasket = preBasket.find((item) => item.assortIds === getId(value));
      return itemBasket ? itemBasket.qnt : 0;
    }
  };

  useEffect(() => {
    if (item.maxSale === 0 || !item.maxSale) {
      setMaxQnt(99);
    } else {
      setMaxQnt(item.maxSale);
    }
  }, []);
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const [maxQnt, setMaxQnt] = useState(0);
  // const ticketsInCurrentBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);

  const ticketsInCurrentBasket = () => {
    if (qntState && qntState.length > 0 && exercise) {
      return qntState
        .filter((item) => item.exerciseIds === exercise.exerciseIds)
        .reduce((acc: number, item: QntStateItem) => acc + item.count, 0);
    } else {
      return preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);
    }
  };

  return (
    <React.Fragment>
      <div
        className={
          getQnt(item) > 0 ? "ticket-line-active ticket-line flex-between-center" : "ticket-line flex-between-center"
        }
      >
        <div className="ticket-line-left flex-start-center">
          <div className="flex-between-center">
            <HiOutlineTicket className="ticket-line-icon" />
            <b>{item.displayWebName}</b>
          </div>

          <React.Fragment>
            {item.description.length > 2 && (
              <React.Fragment>
                {isDesktop ? (
                  <HtmlTooltip
                    placement="right"
                    arrow={true}
                    title={
                      <React.Fragment>
                        <article
                          className="tooltip-description"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></article>
                      </React.Fragment>
                    }
                  >
                    <b>
                      <BiInfoCircle className="tooltip-icon" />
                    </b>
                  </HtmlTooltip>
                ) : (
                  <b onClick={() => setOpen(!open)}>
                    <BiInfoCircle className="tooltip-icon" />
                  </b>
                )}
              </React.Fragment>
            )}
          </React.Fragment>

          {/* {item.passDateValidTo !== null && (
            <div className="ticket-line-promotion">
              Promocja do {format(new Date(item.passDateValidTo), "yyyy-MM-dd")}
            </div>
          )} */}
        </div>

        <div className="ticket-line-right flex-end-center">
          <b className="price">
            {item.price} {t("zl")}
          </b>

          <div className="qnt flex-end-center">
            {getQnt(item) >= item.minSale && getQnt(item) > 0 ? (
              <button
                className="flex-center-center qnt-button onclick-button-move-up"
                onClick={() => removeItemFromBasket(item, exercise)}
              >
                -
              </button>
            ) : (
              <button className="flex-center-center qnt-button-disable onclick-button-move-up">-</button>
            )}

            <input className="qnt-input" type="number" value={getQnt(item)} />

            {ticketLimit || ticketLimit === 0 ? (
              <React.Fragment>
                {getQnt(item) < maxQnt && ticketsInCurrentBasket() < ticketLimit ? (
                  <button
                    className="flex-center-center qnt-button onclick-button-move-up"
                    onClick={() => addItemToBasket(item, exercise)}
                  >
                    +
                  </button>
                ) : (
                  <button className="flex-center-center qnt-button-disable">+</button>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {getQnt(item) < maxQnt ? (
                  <button
                    className="flex-center-center qnt-button onclick-button-move-up"
                    onClick={() => addItemToBasket(item, exercise)}
                  >
                    +
                  </button>
                ) : (
                  <button className="flex-center-center qnt-button-disable">+</button>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
      </div>

      {open && (
        <div className="schedule-modal-info">
          <ModalComponent
            footer={false}
            open={open}
            closeModal={() => setOpen(false)}
            title={item.name}
            onAccept={() => setOpen(false)}
            acceptText={t("przeczytalem")}
          >
            {item.description.length > 1 ? (
              <p className="news-modal-body" dangerouslySetInnerHTML={{ __html: item.description }}></p>
            ) : (
              <p className="news-modal-body">{t("brak_opisu")}</p>
            )}
          </ModalComponent>
        </div>
      )}
    </React.Fragment>
  );
};

export default TicketLineSummary;
